/**
 * The custom URL scheme of the Capacitor native shells (equals the Capacitor
 * appId). Server routes navigate to it to hand short-lived auth codes (or
 * error codes) back to the app; the client parses those callback URLs.
 * Shared so the two sides of the hand-off can't drift apart.
 */
export const MOBILE_OAUTH_CALLBACK_SCHEME = "app.sprocess.mobile";

/**
 * Error codes carried back to the app via the custom scheme. The app treats
 * both as retryable (one automatic sign-in restart): they mean Safari dropped
 * the flow's cookies mid-flight — typically a device's first-ever sign-in
 * attempt tripping bounce-tracking protection — not that the user was denied.
 */
// Emitted by the styled /auth-error page (Auth.js `pages.error`), reached
// when the Google callback fails its PKCE cookie check.
export const MOBILE_AUTH_SIGNIN_INCOMPLETE = "signin_incomplete";
// Emitted by /api/mobile-oauth-finish when the flow-state cookie is missing.
export const MOBILE_AUTH_INVALID_STATE = "invalid_state";

/**
 * Non-retryable codes from the /auth-error page: a fresh attempt can't
 * succeed, so the app surfaces the failure instead of restarting sign-in.
 */
// The account was denied by the sign-in callback.
export const MOBILE_AUTH_ACCESS_DENIED = "access_denied";
// Terminal failure with no more specific code (e.g. a dead magic link).
export const MOBILE_AUTH_SIGNIN_FAILED = "signin_failed";
